// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"631":"54ad8505","703":"03187d3e","787":"d811b756"}[chunkId] + ".chunk.js";
};